export default __webpack_public_path__ + "static/media/danger-sign.5b824cdf.svg";